module.exports = __webpack_public_path__ + "media/images/front/services/prototyping-ffe12431accdab2acde40cb8406c8ecc.jpg";